import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import useBeforeUnloadDialog from '~/hooks/useBeforeUnloadDialog';

type TransferSiteV2PropOptions = {
  changeLoading?: boolean;
  refetchSiteInfo?: VoidFunction;
};

const TransferSiteV2 = ({
  changeLoading = false,
  refetchSiteInfo = () => {},
}: TransferSiteV2PropOptions) => {
  const navigate = useNavigate();
  const { t } = useTranslation('addSites', {
    keyPrefix: 'transferSiteOptions',
  });

  useEffect(() => {
    const timer = setTimeout(() => refetchSiteInfo(), 10000);

    // Clean up the timer on component unmount
    return () => clearTimeout(timer);
  }, [refetchSiteInfo]);

  // Using the custom hook to handle before unload and route change
  useBeforeUnloadDialog(t('unsavedChanges'));

  return (
    <Stack spacing={4} maxWidth={'100%'} data-testid="transfer-site">
      <Stack direction="row" alignItems="center" spacing={2}>
        {changeLoading ? (
          <CircularProgress size={25} data-testid="loading-indicator" />
        ) : (
          <ArrowBackIosIcon
            sx={{ cursor: 'pointer' }}
            onClick={() => navigate(-1)}
            color="primary"
          />
        )}
        <Typography variant="h2">{t('subTitle')}</Typography>
      </Stack>

      <Typography>{t('desc')}</Typography>
    </Stack>
  );
};

export default TransferSiteV2;
